import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private alertService: AlertService, private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                if (error.status === 0) {
                    this.alertService.openInfoNotification('Error', 'No se pudo conectar con el servidor');
                } else if (error.status === 409 || error.status === 406) {
                    this.alertService.openDangerNotification('Error', error.error.message);
                } else if (error.status === 401) {
                    const message = error?.error?.message || '';
                    if (message.toLowerCase().includes('credenciales') || message.toLowerCase().includes('incorrectas')) {
                        // Caso: contraseña incorrecta
                        this.alertService.openInfoNotification('Error', 'Usuario o contraseña incorrecta, verifique e inténtelo de nuevo.');
                    } else {
                        // Caso: sesión expirada
                        this.alertService.openInfoNotification('Sesión expirada', 'Su sesión ha expirado. Por favor, inicie sesión nuevamente.');
                        this.authService.logout();
                    }
                } else if (error.status === 422) {
                    this.alertService.openDangerNotification('Error', error?.error?.message);
                }
                return throwError(() => error);
            })
        );
    }
}
